import React from "react";
import {
  Typography,
  Link,
  makeStyles,
  Theme,
  createStyles
} from "@material-ui/core";

export default function AuthorizationProblemEmailLink() {
  const classes = useStyles({});

  return (
    <Typography variant="caption" className={classes.helpLink}>
      U slučaju problema s AAI autorizacijom, molimo da se obratite isključivo
      na{" "}
      <Link
        href="mailto:etur@mzom.hr"
        target="_blank"
        className={classes.linkText}
      >
        etur@mzom.hr
      </Link>
      .
    </Typography>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    helpLink: {
      width: "100%",
      wordBreak: "break-word",
      color: "#e0e0e0"
    },
    linkText: {
      color: "#e0e0e0"
    }
  })
);
